var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4 text-3xl border-b-2 border-grey-light mb-4"},[_c('span',{staticClass:"font-bold"},[_vm._v("Laravel")]),_vm._v(" "),_c('span',{staticClass:"font-light"},[_vm._v("Ward")])])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c99a59","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TopNavigation.vue
// module id = QOLo
// module chunks = 0